<template>
  <div>
    <!--
      Solo el cliente "solaring" usa la gestión con tabs (civil + mecánico + eléctrico).
    -->
    <certification-manege-solaring v-if="isSolaring" />

    <!-- Resto de clientes: solo certificación civil, sin tabs -->
    <certification-manage v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CertificationManage from '·/components/certifications/CertificationManage.vue'
import CertificationManegeSolaring from '·/components/certifications/CertificationManegeSolaring.vue'

export default {
  name: 'project-certifications',
  middleware: 'auth',
  title: 'certifications',
  subtitle: 'certifications_page_subtitle',
  menuOption: '2-7',

  components: {
    CertificationManage,
    CertificationManegeSolaring,
  },

  computed: {
    ...mapGetters({
      company: 'app/company',
    }),
    // Solo solaring ve los tabs (mecánico/eléctrico por pictogramas). El resto,
    // únicamente la certificación civil.
    isSolaring() {
      return (this.company && this.company.alias) === 'solaring'
    },
  },
}
</script>
